<template>
    <nav class="flex flex-shrink-0">
        <div class="flex-shrink-0 px-4 py-3 bg-gray-700 lg:w-64 lg:bg-gray-800">
            <button
                class="block text-gray-400 hover:text-gray-200 sm:hidden focus:outline-none"
                @click="openSidebar"
            >
                <svg viewBox="0 0 24 24" fill="currentColor" class="h-6 w-6">
                    <path
                        d="M3 6a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1zM3 12a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1zM4 17a1 1 0 100 2h7a1 1 0 100-2H4z"
                    />
                </svg>
            </button>

            <profile />
        </div>
        <div class="flex-1 flex items-center justify-between pl-2 pr-6 bg-gray-700 lg:px-6">
            <!-- ссылки слева -->
            <nav class="hidden sm:flex" v-if="false">
                <a
                    href="https://polished-sunset-0ex44e5cb9xt.tailwindcss.com/components/198272c2-e9b3-46e5-99da-d0911ad1e07c#"
                    class="inline-block px-3 py-2 bg-gray-800 rounded-lg leading-none text-sm font-medium text-white"
                >Mailbox</a>
                <a
                    href="https://polished-sunset-0ex44e5cb9xt.tailwindcss.com/components/198272c2-e9b3-46e5-99da-d0911ad1e07c#"
                    class="ml-2 inline-block px-3 py-2 rounded-lg leading-none text-sm font-medium text-white hover:bg-gray-600"
                >Customers</a>
            </nav>

            <!-- правый блок -->
            <div class="ml-auto flex items-center">
                <!-- search mobile -->
                <button class="lg:hidden ml-5 text-gray-400 hover:text-gray-200" v-if="false">
                    <svg viewBox="0 0 24 24" class="h-5 w-5 fill-current">
                        <path
                            d="M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z"
                        />
                    </svg>
                </button>

                <!-- search -->
                <div class="hidden lg:block relative w-64" v-if="false">
                    <span class="absolute inset-y-0 left-0 flex items-center pl-2">
                        <svg viewBox="0 0 24 24" class="h-5 w-5 fill-current text-gray-500">
                            <path
                                d="M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z"
                            />
                        </svg>
                    </span>
                    <input
                        placeholder="Search"
                        class="block pl-10 pr-4 py-2 w-full bg-gray-800 rounded-lg text-sm placeholder-gray-400 text-white focus:bg-white focus:placeholder-gray-600 focus:text-gray-900 focus:outline-none"
                    />
                </div>

                <!-- notifications -->
                <button class="ml-5 text-gray-400 hover:text-gray-200 focus:outline-none">
                    <svg viewBox="0 0 24 24" class="h-5 w-5 fill-current">
                        <path
                            d="M9.018 4.665a3 3 0 015.964 0A7 7 0 0119 11v3.159c0 .273.109.535.302.729l1.405 1.405A1 1 0 0120 18H4a1 1 0 01-.707-1.707l1.405-1.405c.193-.194.302-.456.302-.73V11a7 7 0 014.018-6.335zM12 4a1 1 0 00-1 1v1.049l-.667.235A5.002 5.002 0 007 11v3.159c0 .669-.221 1.315-.623 1.841h11.246A3.032 3.032 0 0117 14.159V11a5.002 5.002 0 00-3.333-4.716L13 6.05V5a1 1 0 00-1-1zM10 18a2 2 0 004 0h2a4 4 0 11-8 0h2z"
                        />
                    </svg>
                </button>
            </div>
        </div>
    </nav>
</template>

<script>
import Profile from "./profile";

export default {
    components: {
        Profile
    },

    methods: {
        openSidebar() {
            Bus.$emit("open-sidebar");
        }
    }
};
</script>
